import { toast } from "sonner";
import { AlertTriangle, Check, Gift, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const itDate = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "");
export const PRIZE_TAG = "Premio riservato al Cliente";

export const stripPrize = (d) => {
  const out = { ...d, a_condizioni: (d.a_condizioni || "").split("\n").filter((l) => !l.startsWith(PRIZE_TAG)).join("\n") };
  return (d.sconto_motivo || "").startsWith("Premio vinto") ? { ...out, sconto_tipo: "", sconto_valore: "", sconto_motivo: "", sconto_importo: "" } : out;
};

const Chip = ({ children, tone, testId, Icon = Check }) => <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium ${tone}`} data-testid={testId}><Icon size={11} /> {children}</span>;

export function PrizeBox({ premio, kind, id, signedAt, onRevoke, reload }) {
  if (!premio?.nome) return null;
  const ref = (signedAt || new Date().toISOString()).slice(0, 10);
  const expired = ref > premio.scade && !premio.concesso && !premio.revocato;
  const act = async (azione, msg) => {
    try {
      await api.post(`/premio/${kind}/${id}`, { azione });
      if (azione === "revoca") await onRevoke?.();
      toast.success(msg);
      await reload();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className={`rounded-xl border p-4 text-sm space-y-2 ${premio.revocato ? "bg-[#F6F8F9] border-[#D4E6EC] text-[#7B929C]" : expired ? "bg-[#FFF7ED] border-[#FDBA74]" : "bg-[#FBF6EA] border-[#E9D7A8]"}`} data-testid="prize-box">
      <div className="flex items-start gap-3">
        <Gift size={22} className="text-[#C9A96A] shrink-0 mt-0.5" />
        <div className="flex-1 space-y-1">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#A88B5C]">Premio vinto con la richiesta online</div>
          <div className={`font-serif-it text-xl font-semibold ${premio.revocato ? "line-through" : "text-[#0D2B3A]"}`} data-testid="prize-name">{premio.nome}</div>
          <div className="text-xs text-[#47606B]">Valido se il contratto è firmato entro il <b>{itDate(premio.scade)}</b>{premio.vinto_at ? ` • vinto il ${itDate(premio.vinto_at)}` : ""}</div>
          <div className="flex flex-wrap gap-1.5 pt-1">
            {premio.concesso && <Chip tone="bg-[#E0F2FE] text-[#075985]" testId="prize-granted">concesso oltre scadenza ({premio.concesso.by})</Chip>}
            {premio.consegnato && <Chip tone="bg-[#DCFCE7] text-[#166534]" testId="prize-delivered">consegnato il {itDate(premio.consegnato.at)} ({premio.consegnato.by})</Chip>}
            {premio.revocato && <Chip Icon={X} tone="bg-[#F1F5F9] text-[#475569]" testId="prize-revoked">tolto il {itDate(premio.revocato.at)}</Chip>}
          </div>
        </div>
      </div>
      {expired && (
        <div className="flex items-start gap-2 rounded-lg bg-white/70 p-2.5 text-[#9A3412]" data-testid="prize-expired">
          <AlertTriangle size={16} className="shrink-0 mt-0.5" />
          <span>Premio scaduto il {itDate(premio.scade)}{signedAt ? ": il contratto è stato firmato dopo la scadenza" : ""}. Decidete se concederlo comunque o toglierlo.</span>
        </div>
      )}
      {!premio.revocato && (
        <div className="flex flex-wrap gap-2 pt-1">
          {expired && <Button size="sm" className="rounded-full" onClick={() => act("concedi", "Premio concesso comunque")} data-testid="prize-grant">Concedi comunque</Button>}
          {kind === "contract" && !premio.consegnato && <Button size="sm" variant="outline" className="rounded-full" onClick={() => act("consegnato", "Premio segnato come consegnato")} data-testid="prize-deliver"><Check size={13} className="mr-1" /> Premio consegnato</Button>}
          {!premio.consegnato && <Button size="sm" variant="ghost" className="rounded-full text-[#991B1B]" onClick={() => window.confirm("Togliere il premio a questo cliente?") && act("revoca", "Premio tolto")} data-testid="prize-revoke">Togli premio</Button>}
        </div>
      )}
    </div>
  );
}
